export default __webpack_public_path__ + "0979828e54d9f91b646c264266875efe.jpg";